import { get } from 'lodash';

const styles = ({ color }) => ({
  deleteText: {
    color: get(color, 'error'),
    height: '20px',
    backgroundColor: `${get(color, 'white')} !important`,
    borderColor: `${get(color, 'white')} !important`,
  },
  buttonContainer: {
    '& .MuiButtonBase-root.Mui-disabled': {
      color: `${get(color, 'darkGray')} !important`,
      backgroundColor: `${get(color, 'white')} !important`,
      borderColor: `${get(color, 'white')} !important`,
    },
  },
  submitButton: {
    backgroundColor: `${get(color, 'red')} !important`,
    borderColor: `${get(color, 'red')} !important`,
  },
  statusIcon: {
    height: 15,
    marginRight: 3,
    width: 15,
  },
});

export default styles;